import React, { useState } from "react";

// MUI Imports
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import CloseIcon from "@mui/icons-material/Close";
import TextField from "@mui/material/TextField";

// Component Imports
import SuccessAlert from "../../../Components/Interactive/SuccessAlert";
import FailAlert from "../../../Components/Interactive/FailAlert";
import ToolTip from "../../../Components/Interactive/ToolTip";
import EditModal from "../../../Components/EditModal";

import { handlePeopleOptOut } from "./optOutApiHandlers";

const TeaserResultRow = ({
  idx,
  brand,
  row
}) => {
  const formatNames = (names, spacer) => {
    var namesList = [];
    names.forEach((name) => {
      const { firstName, middleName, lastName } = name;
      var nameString = "";
      nameString += firstName;
      if(middleName)
      {
        nameString += " " + middleName;
      }
      nameString += " " + lastName;
      namesList.push(nameString);
    });
    return namesList.join(spacer);
  };

  const getBrandName = (brandId) => {
    switch (brandId) {
      case "1":
        return "Kids Live Safe";
      case "2":
        return "SpyFly";
      case "3":
        return "Public Data Check";
      case "4":
        return "Public Info Services";
      case "5":
        return "Search Public Records";
      case "6":
        return "Public Record Reports";
      default:
        return null;
    }
  };

  const formatCities = (cities, spacer) => {
    var citiesList = [];
    cities.forEach((cityItem) => {
      const { city, state } = cityItem;
      var cityString = city + ", " + state;
      citiesList.push(cityString);
    });
    return citiesList.join(spacer);
  };

  const getNameOfFirstElement = (name) => {
    if(name && name[0])
    {
      const { firstName, middleName, lastName } = name[0];
      var nameString = "";
      nameString += firstName;
      if(middleName)
      {
        nameString += " " + middleName;
      }
      nameString += " " + lastName;
      return nameString;
    }
    else
    {
      return "N/A";
    }
  };

  const getCityOrStateFirstElement = (cityState, itemType) => {
    if(cityState && cityState[0])
    {
      const { city, state} = cityState[0];

      if(itemType === "city")
      {
        return city;
      }
      else{
        return state;
      }
    }
    else
    {
      return "N/A";
    }
  };

  const [errorMessage, setErrorMessage] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [teaserResultRow] = useState(row);
  const [brandId] = useState(brand);
  const [toEmail, setToEmail] = useState("");
  const [modalIsOpen, setModalOpen] = useState(false);

  // Event Handlers - Modals
  const handleOpen = (e) => {
    clearMessages();
    setModalOpen(true);
  }
  const handleClose = (e) => {
    clearMessages();
    setModalOpen(false);
  }

  const clearMessages = async () => {
    setSuccessMessage(null);
    setErrorMessage(null);
  };

  return (
    <>
    <EditModal open={modalIsOpen} handleClose={handleClose} customCSS={{height: "625px"}}>
    <div>
    {
        successMessage ?
        (
          <SuccessAlert>
            {successMessage}
          </SuccessAlert>
        )
        :
        errorMessage ?
          (
            <FailAlert>{errorMessage}</FailAlert>)
          : null
     }
    </div>      
      <div className="modal-header">
        <h2 style={{ padding: ".5rem", color: "#6acde6"}}>Opt Out</h2>
        <CloseIcon
          className="close-icons"
          onClick={() => handleClose()}
        />
      </div>
      <TextField
                id="outlined-full-width"
                className="input-el"
                type={"text"}
                label="To Email"
                name="expiration_Date"
                style={{ margin: 6, width: "14rem" }}
                fullWidth={false}
                margin="normal"
                InputLabelProps={{ shrink: true }}
                variant="outlined"
                value={toEmail}
                onChange={(e) => setToEmail(e.target.value)}
              />   
      <div className="data-highlight">
        <h6>Report Token</h6>
        <p>{teaserResultRow.reportToken}</p>
        <br/>
        <h6>Brand</h6>
        <p>{getBrandName(brandId)}</p>
        <br/>
        <h6>Aliases</h6>
        <p>{formatNames(teaserResultRow.names, ", ")}</p>
        <br/>
        <h6>Relatives</h6>
        <p style={{ whiteSpace:"pre-wrap"}}>{formatNames(teaserResultRow.relatives, ", ")}</p>
        <br/>
        <h6>Cities</h6>
        <p>{formatCities(teaserResultRow.cities, " - ")}</p>
        <br/>
      </div>
      <button
        className="submit-note-btn moveRight"
        onClick={(e) => handlePeopleOptOut(teaserResultRow.reportToken, teaserResultRow.names[0], teaserResultRow.age, teaserResultRow.cities[0], brandId, toEmail, clearMessages, setErrorMessage, setSuccessMessage)}
      >
        <span style={{ color: "#fff" }}>Submit Opt Out</span>
      </button>
    
  </EditModal>
    <TableRow className="order-row table-row" key={idx}>
      <ToolTip
        placement="top"
        titleHeading="Aliases"
        titleData={formatNames(teaserResultRow.names, "\n")}
        >
      <TableCell align="center" className="tableCell">
        {getNameOfFirstElement(teaserResultRow.names)}
      </TableCell>
      </ToolTip>
      <TableCell align="center" className="tableCell">
        {teaserResultRow.reportToken}
      </TableCell>
      <TableCell align="center" className="tableCell">
        {teaserResultRow.age}
      </TableCell>
      <ToolTip
        placement="top"
        titleHeading="City, State History"
        titleData={formatCities(teaserResultRow.cities, "\n")}
        >
      <TableCell align="center" className="tableCell">
        {getCityOrStateFirstElement(teaserResultRow.cities, "city")}
      </TableCell>
      </ToolTip>
      <TableCell align="center" className="tableCell">
        {getCityOrStateFirstElement(teaserResultRow.cities, "state")}
      </TableCell>
      <ToolTip
        placement="top"
        titleHeading="Relatives"
        titleData={formatNames(teaserResultRow.relatives, "\n")}
        >
      <TableCell align="center" className="tableCell">
        {getNameOfFirstElement(teaserResultRow.relatives)}
      </TableCell>
      </ToolTip>
      <TableCell className="tableCell" align="center">
        <button
            onClick={() => {handleOpen();}}
            className="update-lockout-btn"
          >
            <span>Opt Out</span>
        </button>
      </TableCell>
    </TableRow>
    </>
  );
};

export default TeaserResultRow;
